/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `Deal` - DEAL
* `ExternalLoad` - EXTERNAL_LOAD
* `Inspection` - INSPECTION
* `Load` - LOAD
* `PurchaseOrder` - PURCHASE_ORDER
* `SalesOrder` - SALES_ORDER
* `Shipment` - SHIPMENT
* `TradeCompany` - TRADE_COMPANY
* `Claim` - CLAIM
 */
export type ContextModelNameEnum = typeof ContextModelNameEnum[keyof typeof ContextModelNameEnum];


export const ContextModelNameEnum = {
  Deal: 'Deal',
  ExternalLoad: 'ExternalLoad',
  Inspection: 'Inspection',
  Load: 'Load',
  PurchaseOrder: 'PurchaseOrder',
  SalesOrder: 'SalesOrder',
  Shipment: 'Shipment',
  TradeCompany: 'TradeCompany',
  Claim: 'Claim',
} as const;
